// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const shellder: PokeData = {
  "id": 90,
  "name": "shellder",
  "height": 3,
  "weight": 40,
  "base_experience": 61,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "tackle",
    "leer",
    "supersonic",
    "water-gun",
    "hydro-pump",
    "ice-beam",
    "aurora-beam",
    "withdraw",
    "clamp",
    "protect",
    "whirlpool",
    "icicle-spear",
    "iron-defense",
    "brine",
    "ice-shard",
    "shell-smash",
    "razor-shell"
  ],
  "moves": [
    "tackle",
    "leer",
    "supersonic",
    "hydro-pump",
    "protect",
    "whirlpool",
    "brine",
    "ice-shard",
    "life-dew",
    "aqua-jet",
    "bubble",
    "bubble-beam",
    "liquidation"
  ],
  "evolution_chain": {
    "id": 39,
    "item": null,
    "species": [
      {
        "name": "shellder",
        "order": 98,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "cloyster",
        "order": 99,
        "types": [
          PokeType.WATER,
          PokeType.ICE
        ],
        "evolves_from_species_id": 90,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "water-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 46.25,
    "speed": 40,
    "ability_power": 65
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
